import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../store/index";
import { roles } from "../../helpers/constantVariables";
import { AiOutlineUser } from "react-icons/ai";
import { GrOrganization } from "react-icons/gr";
import RegisterDetails from "./registerDetails";
export default function Register({ onBack1 }) {
  const [studentchecked, setStudentChecked] = useState(false);
  const [employeechecked, setEmployeeChecked] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const { UserStore } = useStores();
  const [register, setRegister] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const recuiter = queryParams.get("employer");

  const handleStudentClick = () => {
    if (recuiter) {
      alert("You are not allowed to register as a student");
      return;
    }
    setStudentChecked(!studentchecked);
    setIsButtonEnabled(!isButtonEnabled);
    setEmployeeChecked(false);

    UserStore.setRole(roles[0].id);
  };
  const handleEmployeeClick = () => {
    if (!recuiter) {
      alert("You are not allowed to register as a recruiter");
      return;
    }
    setEmployeeChecked(!employeechecked);
    setIsButtonEnabled(!isButtonEnabled);
    setStudentChecked(false);
    UserStore.setRole(roles[1].id);
  };

  const handleButton = () => {
    if (studentchecked || employeechecked) {
      return setRegister(true);
    }
    return alert("Please select one option");
  };

  const skipOption = () => {
    if (!recuiter) {
      setStudentChecked(!studentchecked);
      setIsButtonEnabled(!isButtonEnabled);
      setEmployeeChecked(false);

      UserStore.setRole(roles[0].id);
    } else {
      setEmployeeChecked(!employeechecked);
      setIsButtonEnabled(!isButtonEnabled);
      setStudentChecked(false);
      UserStore.setRole(roles[1].id);
    }
    return setRegister(true);
  };

  useEffect(() => {
    skipOption();
  }, []);
  return (
    <>
      {register ? (
        <RegisterDetails
          onBack={() => {
            setRegister(false);
            onBack1();
          }}
        />
      ) : (
        <div className="flex flex-col h-[100vh]  justify-center items-center bg-[#F8F2E9]">
          {/* <img
            src={getLogoForWhiteLabeling()}
            className=" h-16  mt-auto object-cover"
          ></img> */}
          <div className="px-6 md:px-24 lg:px-24 py-10 text-center">
            {recuiter ? (
              <p>
                " Secure your path with us! Specify if you're a recruiter
                seeking top talent or a student beginning your academic journey.
                Your door to tailored opportunities is here!"
              </p>
            ) : (
              <p>
                "Embark on your academic adventure with us! Your gateway to
                personalized experiences tailored to students is just a click
                away. Let the journey to success begin!"
              </p>
            )}
            {/* <h1 className="text-2xl font-bold mt-auto py-3">Select One </h1> */}
          </div>

          <div className=" mx-auto mb-auto mt-3 w-[90%] md:w-[60%] lg:w-[60%] py-[3%]  flex flex-col justify-center  items-center">
            <div className="flex w-[90%] justify-between">
              {!recuiter ? (
                <div className="flex flex-col gap-3 justify-center w-[100%] items-center ">
                  <div
                    onClick={handleStudentClick}
                    className={`${
                      studentchecked
                        ? "border  border-primary"
                        : "border  border-black"
                    } ${
                      recuiter && "opacity-25"
                    } p-5 cursor-pointer rounded-full`}
                  >
                    <AiOutlineUser className="text-6xl" />
                  </div>
                  <button
                    className="flex items-center"
                    onClick={handleStudentClick}
                  >
                    <div
                      className={`${
                        studentchecked ? " bg-primary" : "bg-gray-100"
                      } w-3 h-3  border border-gray-400 rounded-full cursor-pointer`}
                    />
                    <p
                      className={`text-xs ml-1 ${
                        studentchecked ? "text-primary" : null
                      } `}
                    >
                      Student/job-seeker
                    </p>
                  </button>
                </div>
              ) : (
                <div className="flex flex-col gap-3  w-[100%] justify-center items-center ">
                  <div
                    onClick={handleEmployeeClick}
                    className={`${
                      employeechecked
                        ? "border  border-primary"
                        : "border  border-black"
                    } ${
                      !recuiter && "opacity-25"
                    } p-5 cursor-pointer rounded-full`}
                  >
                    <GrOrganization className="text-6xl" />
                  </div>
                  <button
                    className="flex items-center"
                    onClick={handleEmployeeClick}
                  >
                    <div
                      className={`${
                        employeechecked ? " bg-primary" : "bg-gray-100"
                      } w-3 h-3  border border-gray-400 rounded-full cursor-pointer`}
                    />
                    <p
                      className={`text-xs ml-1 ${
                        employeechecked ? "text-primary" : null
                      } `}
                    >
                      Recruiter/Company
                    </p>
                  </button>
                </div>
              )}
            </div>
            <div className="pt-10 ">
              <button
                onClick={handleButton}
                className={`${
                  studentchecked || employeechecked
                    ? " border border-primary"
                    : "border  border-gray-500"
                } bg-primary text-white py-2 mt-8  text-sm px-20 rounded-full  `}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
